export default class SiteFooter extends HTMLElement {
    constructor() {
        super();
        this.backtotop = this.querySelector('.backtotop-cta');
        this.handleScrollPosition = this.handleScrollPosition.bind(this);
    }

    connectedCallback() {
        if (this.backtotop) {
            this.backtotop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
            window.addEventListener('scroll', this.handleScrollPosition);
            window.addEventListener('resize', this.handleScrollPosition);
            this.handleScrollPosition(); // Initial check
        }
    }

    disconnectedCallback() {
        if (this.backtotop) {
            window.removeEventListener('scroll', this.handleScrollPosition);
            window.removeEventListener('resize', this.handleScrollPosition);
        }
    }

    handleScrollPosition() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        this.backtotop.classList.toggle('active', scrollTop > 150);
    }
}